import api from "../api/api";

class ManifestoService {
    async getAllPaginate(search: string, page: string | null) {
        let q = '';
        if (search?.length > 0) {
            q = `?q=${search}`;
            q += page ? `&page=${page}` : "";
            return await api.get(`/manifesto${q}`).then(r => r.data).catch(err => err);
        } else {
            if (page) {
                return await api.get(`/manifesto?page=${page}`).then(r => r.data).catch(err => err);
            } else {

                return await api.get(`manifesto`).then(r => r.data).catch(err => err);
            }
        }
    }

    async get(id: string) {
        return await api.get(`/manifesto/${id}`).then(response => response.data).catch(err => err);
    }

    async create(data: any) {
        return await api.post("/manifesto", data).then(response => response.data);
    }

    async update(id: string, data: any) {
        return await api.put(`/manifesto/${id}`, data).then(response => response.data);
    }

    async delete(id: string) {
        return await api.delete(`/manifesto/${id}`).then(response => response.data);
    }

    async statusServico() {
        return await api.get(`/mdfe/status`).then(response => response.data);
    }

    async transmitir(id: string) {
        return await api.post(`/mdfe/operacao/transmitir/${id}`).then(response => response.data);
    }

    async encerrar(id: string) {
        return await api.post(`/mdfe/operacao/encerrar/${id}`).then(response => response.data);
    }

    async cancelar(id: string) {
        return await api.post(`/mdfe/operacao/cancelar/${id}`).then(response => response.data);
    }

    async incluirCondutor(id: string, nome: string, cpf:string) {
        return await api.post(`/mdfe/operacao/incluirCondutor/${id}`, {nome: nome, cpf:cpf}).then(res => res.data);
    }

    async incluirDFe (id: string, data: any) {
        return await api.post(`/mdfe/operacao/incluirDFe/${id}`, data).then(res => res.data);
    }

    async damdfe(id: string) {
        return await api.get(`/mdfe/operacao/imprimir/${id}`, {
            responseType: 'blob',
            headers: {
                'Accept': 'application/pdf',
            },
        }).then(response => response.data);
    }

    async getDadosInclusaoDFe(id: string) {
        return await api.get(`/mdfe/operacao/municipios/${id}`).then(res => res.data);
    }
  async getListaDFesIncluidos(id: number | string) {
        return await api.get(`/manifesto/lista/listaDFes/${id}`).then(res => res.data);
    }
}

const manifestoService = new ManifestoService();

export default manifestoService;